
















































import {API} from '@/services/api/api';
import {extractDetailsFromBase64} from '@/services/api/image';
import {getInspectionData} from '@/store/getters';
import {Utils} from '@/utils/Utils';
import moment from 'moment';
import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {mapActions, mapGetters} from 'vuex';

@Component({
  methods: {
    ...mapActions(['showSuccessToast', 'showErrorToast']),
  },
  computed: {
    ...mapGetters(['getInspectionData']),
  },
})
export default class CopyReInspection extends Vue {
  isCheckboxSelected = false;
  getInspectionData: any;
  showSuccessToast: any;
  showErrorToast: any;
  btnLoader = false;
  inspectionCode = '';
  inspectionId = this.$route.params.id;
  inspectionData: any;
  zoneMasterId: number = null;
  isScreenLoading = true;
  parentReInspectionCode = null;

  mounted() {
    this.getInspectionDataById();
  }

  async getInspectionDataById() {
    try {
      const response = await API.fetchInspectionDataById(this.inspectionId);

      if (response.data) {
        const data = response.data;
        this.inspectionData = data;
        this.zoneMasterId = data.inspectionPoint.zoneMasterId;
        this.parentReInspectionCode = data.parentInspectionId;
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.isScreenLoading = false;
      this.showErrorToast({msg: 'Network Error'});
    } finally {
      this.isScreenLoading = false;
    }
  }

  async onSaveClick() {
    this.btnLoader = true;
    try {
      const currentDate = moment(new Date()).format('YYYY-MM-DDTHH:mm:ss');

      const reInspectionDate = moment(new Date()).add(1, 'M').format('YYYY-MM-DDTHH:mm:ss');

      const inspectionCode = await this.getReInspectionCode();
      if (inspectionCode === undefined) {
        this.showErrorToast({msg: 'Something went wrong'});
        return;
      } else this.inspectionCode = inspectionCode;

      const attachments = this.inspectionData.inspectionAttachment;

      const modifyAttachment = await Promise.all(
        attachments.map(async (me) => {
          const filePath = me.filePath + me.fileName;
          const blobResponse = await API.convertImgURLToBLob(filePath);
          const base64Url = await Utils.ngxBase64(blobResponse);
          const sendAbleUrl = extractDetailsFromBase64(base64Url).url;
          const fileType = extractDetailsFromBase64(base64Url).imageType;

          return {
            ...me,
            attachmentId: null,
            filePath: sendAbleUrl,
            fileType: fileType,
          };
        })
      );

      const params = {...this.inspectionData};

      const inspectionDetail = params.inspectionDetail;
      inspectionDetail['inspectionDate'] = currentDate;
      inspectionDetail['reInspectionDate'] = reInspectionDate;
      inspectionDetail['inspectionID'] = this.inspectionCode;
      params['inspectionAttachment'] = modifyAttachment;

      delete params.deck;
      delete params.inspectionId;

      //

      const response = await API.createReInspection(params);
      if (response.data) {
        this.showSuccessToast({msg: response.message});
        this.$router.push('/inspection-list');
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network Error'});
    } finally {
      this.btnLoader = false;
    }
  }

  async getReInspectionCode() {
    try {
      const response = await API.fetchReInspectionId(this.parentReInspectionCode);
      if (response.data) {
        const data = response.data;

        return data.inspectioncode;
      } else {
        this.showErrorToast({msg: response.error});
        return response.error;
      }
    } catch (error) {
      this.showErrorToast({msg: error});
      return error;
    }
  }
}
